























































































import Vue from 'vue';

import settingsPannel from '../settings.vue';

import { MDCTextField } from '@material/textfield';
import { MDCSnackbar } from '@material/snackbar';
import Axios from 'axios';

interface Data {
  newUserEmail: string;
  newUserPass: string;
  newUserIsAdmin: boolean;
}

export default Vue.extend({
  data(): Data {
    return {
      newUserEmail: '',
      newUserPass: '',
      newUserIsAdmin: false,
    };
  },
  mounted() {
    this.makeUpElements();
  },
  updated() {
    this.makeUpElements();
  },
  methods: {
    makeUpElements() {
      const textFields: any = document.querySelectorAll('#addUser .mdc-text-field');
      for (const textFieldElem of textFields) {
        const textField = new MDCTextField(textFieldElem);
      }
    },
    addUser() {
      const reqObj: any = {
        Email: this.newUserEmail,
        Pass: this.newUserPass,
        Admin: this.newUserIsAdmin,
      };

      Axios.post('/API/admin/addUser', reqObj).then((resp: any) => {
        const data: any = resp.data;
        this.$router.push('/editUser/' + data.ID);
      }).catch((err: any) => {
        const elem = document.querySelector('#addUser .mdc-snackbar.fail');
        if (elem === null) {
          return;
        }

        const snackbarF: any = new MDCSnackbar(elem);
        snackbarF.open();
        console.warn(err);
      });
    },
  },
  components: {
    settingsPannel,
  },
});
